<template>
    <div v-if="loaded">
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-area
                :class="{ 'pb-0': !boxPacienteVisible }"
                id="box-paciente"
                title="Dados do paciente"
                type="fieldset"
            >
                <template slot="trailing">
                    <rkm-button
                        @click="boxPacienteVisible = !boxPacienteVisible"
                        color="primary"
                        small
                    >
                        <rkm-icon :icon="boxPacienteVisible ? 'angle-double-up' : 'angle-double-down'" />
                    </rkm-button>
                </template>

                <rkm-collapse :visible="boxPacienteVisible">
                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-input
                                disabled
                                label="Nome"
                                v-model="form.paciente.nome"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-input
                                disabled
                                label="Prontuário"
                                v-model="form.paciente.prontuario"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-input
                                disabled
                                label="Data de nascimento"
                                v-model="form.paciente.dataNascimento"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="3">
                            <rkm-form-input
                                disabled
                                label="Idade"
                                v-model="form.paciente.idade"
                            />
                        </rkm-col>

                        <rkm-col>
                            <rkm-form-input
                                disabled
                                label="Raça/cor"
                                v-model="form.paciente.racaCor"
                            />
                        </rkm-col>

                        <rkm-col>
                            <rkm-form-input
                                disabled
                                label="Sexo"
                                v-model="form.paciente.sexo"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-input
                                disabled
                                label="Nome da mãe"
                                v-model="form.paciente.nomeMae"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="2">
                            <rkm-form-input
                                :disabled="!additionals.allowUpdate"
                                :validations="validations.cns"
                                label="CNS"
                                v-mask="mask.cns"
                                v-model="form.paciente.cns"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-input
                                :disabled="!additionals.allowUpdate"
                                :validations="validations.cpf"
                                label="CPF"
                                v-mask="mask.cpf"
                                v-model="form.paciente.cpf"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-input
                                :disabled="!additionals.allowUpdate"
                                :validations="validations.rg"
                                label="RG"
                                v-model="form.paciente.rg"
                            />
                        </rkm-col>

                        <rkm-col
                            v-if="additionals.exibeProtocoloCross"
                            cols="2"
                        >
                            <rkm-form-input
                                :disabled="!additionals.allowUpdate"
                                :validations="validations.protocoloCross"
                                label="Prontuário estadual"
                                v-model="form.paciente.protocoloCross"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-input
                                :disabled="!additionals.allowUpdate || !additionals.permiteAlterarAntropometria"
                                :validations="validations.peso"
                                append="kg"
                                label="Peso"
                                placeholder="000.00"
                                v-mask="pesoMask"
                                v-model="model.peso"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-input
                                :disabled="!additionals.allowUpdate || !additionals.permiteAlterarAntropometria"
                                :validations="validations.altura"
                                append="cm"
                                label="Altura"
                                placeholder="000"
                                v-mask="'###'"
                                v-model="model.altura"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-input
                                disabled
                                label="Endereço"
                                v-model="form.paciente.endereco"
                            />
                        </rkm-col>

                        <rkm-col
                            v-if="additionals.allowUpdate"
                            cols="auto"
                        >
                            <rkm-button
                                :label="false"
                                @click="$refs.ModalTentativaContato.open()"
                                color="primary"
                            >
                                Tentativa de contato
                            </rkm-button>
                        </rkm-col>

                        <rkm-col cols="auto">
                            <rkm-form-radio-group
                                :disabled="!additionals.allowUpdate || fezAgendamentoAgora"
                                @change="handleObito"
                                class="mb-0"
                                label="Óbito"
                                v-model="model.obito"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-area
                        v-if="model.obito"
                        title="Óbito"
                        type="fieldset"
                    >
                        <rkm-row>
                            <rkm-col cols="2">
                                <rkm-form-date-picker
                                    :disabled="!additionals.allowUpdate"
                                    :max-date="additionals.dataAtual"
                                    :validations="validations.obito.obitoEm"
                                    label="Data do óbito"
                                    v-model="form.paciente.obito.obitoEm"
                                />
                            </rkm-col>

                            <rkm-col cols="2">
                                <rkm-form-input
                                    :disabled="!additionals.allowUpdate"
                                    :validations="validations.obito.declaracao"
                                    label="Declaração"
                                    number
                                    v-model="form.paciente.obito.declaracao"
                                />
                            </rkm-col>

                            <rkm-col cols="8">
                                <rkm-form-input
                                    :disabled="!additionals.allowUpdate"
                                    :validations="validations.obito.causa"
                                    label="Causa"
                                    v-model="form.paciente.obito.causa"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="6">
                                <rkm-form-input-autocomplete
                                    :disabled="!additionals.allowUpdate"
                                    :repository="repositories.cid"
                                    :search-fields="[
                                        { key: 'cid.codigo', searchable: true },
                                        { key: 'cid.nome', searchable: true },
                                    ]"
                                    :text-field="c => `${c.codigo} - ${c.nome}`"
                                    label="CID"
                                    v-model="form.paciente.obito.cid"
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <rkm-form-input-autocomplete
                                    :disabled="!additionals.allowUpdate"
                                    :repository="repositories.usuario"
                                    :search-fields="[
                                        { key: 'cadastroCidadao.nome', searchable: true },
                                        { key: 'cadastroCidadao.cns', searchable: true },
                                    ]"
                                    :text-field="u => u.cidadaoCns ? `${this.formatCns(u.cidadaoCns)} - ${u.cidadaoNome}` : u.cidadaoNome"
                                    label="Profissional"
                                    v-model="form.paciente.obito.usuario"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>

                    <rkm-row>
                        <rkm-col>
                            <rkm-button
                                v-if="hasPermissao('show-ambulatorio-historico-atendimento')"
                                :label="false"
                                @click.stop="$refs.ModalHistoricoMedico.open()"
                                color="primary"
                            >
                                Visualizar todo o histórico de atendimento
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>

                    <ModalHistoricoMedico
                        :data="form.historicoAmbulatorio"
                        ref="ModalHistoricoMedico"
                    />

                </rkm-collapse>
            </rkm-area>

            <rkm-area
                :class="['mt-3', { 'pb-0': !boxInformacoesVisible }]"
                id="box-paciente"
                title="Informações da solicitação"
                type="fieldset"
            >
                <template slot="trailing">
                    <rkm-button
                        @click="boxInformacoesVisible = !boxInformacoesVisible"
                        color="primary"
                        small
                    >
                        <rkm-icon :icon="boxInformacoesVisible ? 'angle-double-up' : 'angle-double-down'" />
                    </rkm-button>
                </template>

                <rkm-collapse :visible="boxInformacoesVisible">
                    <rkm-row>
                        <rkm-col cols="2">
                            <rkm-form-input
                                disabled
                                label="Data da solicitação"
                                v-model="form.solicitacao.data"
                            />
                        </rkm-col>

                        <rkm-col>
                            <rkm-form-input
                                disabled
                                label="Profissional solicitante"
                                v-model="form.solicitacao.usuarioSolicitanteNome"
                            />
                        </rkm-col>

                        <rkm-col>
                            <rkm-form-input
                                disabled
                                label="CBO do profissional solicitante"
                                v-model="form.solicitacao.usuarioSolicitanteOcupacao"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-input
                                :append="form.solicitacao.usuarioSolicitanteRegistroEstado"
                                label="Conselho do profissional soliciante"
                                :prepend="form.solicitacao.usuarioSolicitanteRegistroTipo"
                                disabled
                                v-model="form.solicitacao.usuarioSolicitanteRegistroNumero"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-input
                                disabled
                                label="CID"
                                v-model="form.solicitacao.cid"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-input
                                disabled
                                label="CIAP"
                                v-model="form.solicitacao.ciap"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col class="text-right">
                            <rkm-button
                                :label="false"
                                @click.stop="$refs.ModalImportaArquivo.open(form.paciente, model, additionals)"
                                color="primary"
                            >
                                Arquivos
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>

                    <ModalImportaArquivo
                        ref="ModalImportaArquivo"
                    />

                    <rkm-row>
                        <rkm-col>
                            <rkm-area
                                title="Prioridade"
                                type="fieldset"
                                no-margin-top
                            >
                                <rkm-row>
                                    <rkm-col cols="3">
                                        <rkm-form-input
                                            disabled
                                            v-model="form.solicitacao.prioridadeNome"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="auto">
                                        <rkm-button
                                            v-if="additionals.allowUpdate"
                                            @click="$refs.ModalPrioridade.open()"
                                            color="primary"
                                            small
                                            title="Editar"
                                        >
                                            Alterar prioridade
                                        </rkm-button>
                                    </rkm-col>
                                </rkm-row>

                                <rkm-area
                                    no-margin-top
                                    title="Histório de alterações"
                                >
                                    <template slot="trailing">
                                        <rkm-button
                                            @click="boxHistoricoPrioridadeVisible = !boxHistoricoPrioridadeVisible"
                                            color="primary"
                                            small
                                        >
                                            <rkm-icon :icon="boxHistoricoPrioridadeVisible ? 'angle-double-up' : 'angle-double-down'" />
                                        </rkm-button>
                                    </template>

                                    <rkm-collapse :visible="boxHistoricoPrioridadeVisible">
                                        <rkm-table
                                            :items="form.historicoMovimentacoes.prioridade"
                                            :fields="fields.historicoMovimentacoesPrioridade"
                                            hide-filters
                                            sort-by="dataHoraMovimentacao"
                                            sort-desc
                                        >
                                            <template v-slot:cell(motivoAlteracaoPrioridade)="{ item }">
                                                <rkm-button
                                                    :id="uniqueId(`motivo-alteracao-prioridade-${item.solicitacaoHistoricoId}`)"
                                                    small
                                                >
                                                    <rkm-icon icon="comment" />
                                                </rkm-button>

                                                <rkm-popover
                                                    :target="uniqueId(`motivo-alteracao-prioridade-${item.solicitacaoHistoricoId}`)"
                                                    placement="top"
                                                    triggers="hover"
                                                >
                                                    {{ item.motivoAlteracaoPrioridade }}
                                                </rkm-popover>
                                            </template>
                                        </rkm-table>
                                    </rkm-collapse>
                                </rkm-area>
                            </rkm-area>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-area
                                title="Procedimento(s) / Especialidade"
                                type="fieldset"
                                no-margin-top
                            >
                                <rkm-table
                                    :fields="fields.itens"
                                    :items="form.solicitacao.itens"
                                    hide-filters
                                    hide-pagination
                                />
                            </rkm-area>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-textarea
                                disabled
                                label="Hipótese diagnóstica / Justificativa"
                                v-model="form.solicitacao.hipoteseDiagnosticaJustificativa"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-textarea
                                disabled
                                label="Observação"
                                v-model="form.solicitacao.observacao"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-area
                        no-margin-top
                        title="Outras solicitações"
                    >
                        <template slot="trailing">
                            <rkm-button
                                @click="boxHistoricoOutrasSolicitacoesVisible = !boxHistoricoOutrasSolicitacoesVisible"
                                color="primary"
                                small
                            >
                                <rkm-icon :icon="boxHistoricoOutrasSolicitacoesVisible ? 'angle-double-up' : 'angle-double-down'" />
                            </rkm-button>
                        </template>

                        <rkm-collapse :visible="boxHistoricoOutrasSolicitacoesVisible">
                            <rkm-table
                                :items="form.historicoOutrasSolicitacoes"
                                :fields="fields.historicoOutrasSolicitacoes"
                                hide-filters
                                sort-by="data"
                                sort-desc
                            >
                                <template v-slot:cell(itens)="{ value }">
                                    <div
                                        v-for="item in value"
                                        :key="item"
                                    >
                                        {{ item }}
                                    </div>
                                </template>
                            </rkm-table>
                        </rkm-collapse>
                    </rkm-area>
                </rkm-collapse>
            </rkm-area>

            <rkm-area
                class="mt-3"
                id="box-paciente"
                title="Movimentação da solicitação"
                type="fieldset"
            >
                <template v-if="additionals.allowUpdate">

                    <rkm-alert
                        color="info"
                        v-if="additionals.iniciouAtendimento"
                    >
                        Atendimento iniciado no módulo agendado.
                    </rkm-alert>

                    <rkm-row>
                        <rkm-col cols="2">
                            <rkm-form-select
                                :disabled="fezAgendamentoAgora"
                                :options="status"
                                :validations="validations.status"
                                label="Status"
                                show-default-option
                                text-field="nome"
                                v-model="model.statusId"
                                value-field="id"
                            />
                        </rkm-col>

                        <template v-if="isStatusDeAgendamento">
                            <rkm-col
                                v-if="isRegulacaoTipoAmbos"
                                cols="auto"
                            >
                                <rkm-form-radio-group
                                    :disabled="fezAgendamentoAgora"
                                    @change="clearFromTipoPrestador"
                                    label="Tipo de prestador"
                                    v-model="form.prestadorTipo"
                                >
                                    <rkm-form-radio :value="enums.regulacaoTipo.INTERNO">Interno</rkm-form-radio>
                                    <rkm-form-radio :value="enums.regulacaoTipo.EXTERNO">Externo</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>

                            <template v-if="isRegulacaoTipoInterno || (isRegulacaoTipoAmbos && isPrestadorTipoInterno)">
                                <rkm-col>
                                    <rkm-form-select
                                        :disabled="fezAgendamentoAgora"
                                        :options="form.prestadoresInternos"
                                        :validations="validations.prestadorInterno"
                                        label="Prestador interno"
                                        show-default-option
                                        text-field="nome"
                                        v-model="model.prestadorInternoId"
                                        value-field='id'
                                    />
                                </rkm-col>
                            </template>

                            <template v-if="isRegulacaoTipoExterno || (isRegulacaoTipoAmbos && isPrestadorTipoExterno)">
                                <rkm-col>
                                    <rkm-form-select
                                        :options="form.prestadoresExternos"
                                        :validations="validations.prestadorExterno"
                                        label="Prestador externo"
                                        show-default-option
                                        text-field="nome"
                                        v-model="model.prestadorExternoId"
                                        value-field='id'
                                    />
                                </rkm-col>
                            </template>

                            <rkm-col cols="2">
                                <rkm-form-date-picker
                                    :disabled="isPrestadorTipoInterno || fezAgendamentoAgora"
                                    :min-date="additionals.dataAtual"
                                    :validations="validations.dataAgendada"
                                    label="Data agendada"
                                    v-model="model.dataAgendada"
                                />
                            </rkm-col>

                            <rkm-col cols="2">
                                <rkm-form-time-picker
                                    :disabled="isPrestadorTipoInterno || fezAgendamentoAgora"
                                    :validations="validations.horaAgendada"
                                    label="Hora agendada"
                                    right
                                    v-model="model.horaAgendada"
                                />
                            </rkm-col>
                        </template>

                        <rkm-col
                            v-else-if="isStatusRealizado"
                            cols="2"
                        >
                            <rkm-form-date-picker
                                disabled
                                label="Data"
                                v-model="form.solicitacao.dataAgendada"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row v-if="isStatusDeAgendamento && (isPrestadorTipoExterno || savedProtocoloAgendamento)">
                        <rkm-col cols="2">
                            <rkm-form-select
                                :options="form.opcoesRetiradaProtocoloAgendamento"
                                label="Retirada do protocolo"
                                text-field="nome"
                                v-model="model.opcaoRetiradaProtocoloAgendamentoId"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col v-if="model.opcaoRetiradaProtocoloAgendamentoId === enums.opcaoRetiradaProtocoloAgendamento.RETIRADO">
                            <rkm-form-input
                                :validations="validations.nomePessoaRetiradaProtocoloAgendamento"
                                label="Nome de quem retirou o protocolo"
                                uppercase
                                v-model="model.nomePessoaRetiradaProtocoloAgendamento"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row v-if="isStatusCancelado">
                        <rkm-col>
                            <rkm-form-textarea
                                :validations="validations.justificativaCancelamento"
                                label="Justificativa"
                                v-model="model.justificativaCancelamento"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row v-if="isStatusReagendado">
                        <rkm-col>
                            <rkm-form-textarea
                                :validations="validations.justificativaReagendamento"
                                label="Justificativa"
                                v-model="model.justificativaReagendamento"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row v-if="isStatusRemarcar">
                        <rkm-col>
                            <rkm-form-textarea
                                :validations="validations.justificativaRemarcacao"
                                label="Justificativa"
                                v-model="model.justificativaRemarcacao"
                            />
                        </rkm-col>
                    </rkm-row>

                    <template v-if="isStatusReenviada">
                        <rkm-row>
                            <rkm-col cols="6">
                                <rkm-form-input-autocomplete
                                    :repository="repositories.usuario"
                                    :requestQueryStringParams="autocompleteRequestParams.usuario"
                                    :searchFields="[{ key: 'cadastro_cidadao.nome', searchable: true }]"
                                    :validations="validations.usuarioSolicitante"
                                    @select="handleUsuarioSolicitanteSelected"
                                    @input="handleUsuarioSolicitanteInput"
                                    label="Profissional solicitante"
                                    placeholder="Digite o nome do profissional"
                                    text-field="cidadaoNome"
                                    uppercase
                                    v-model="model.usuarioSolicitante"
                                    value="id"
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <rkm-form-select
                                    :disabled="!model.usuarioSolicitante"
                                    :options="form.unidadesUsuarioSolicitante"
                                    :validations="validations.unidadeUsuarioSolicitante"
                                    @change="handleUnidadeUsuarioSolitanteChange"
                                    label="Unidade do profissional solicitante"
                                    show-default-option
                                    text-field="nomeFantasia"
                                    v-model="model.unidadeUsuarioSolicitanteId"
                                    value-field="id"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="6">
                                <rkm-form-select
                                    :disabled="!model.unidadeUsuarioSolicitanteId"
                                    :options="form.infraestruturasUsuarioSolicitante"
                                    :validations="validations.infraestruturaUsuarioSolicitante"
                                    @change="handleInfraestruturaUsuarioSolitanteChange"
                                    label="Local de atendimento do profissional solicitante"
                                    show-default-option
                                    text-field="nome"
                                    v-model="model.infraestruturaUsuarioSolicitanteId"
                                    value-field="id"
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <rkm-form-select
                                    :disabled="!model.infraestruturaUsuarioSolicitanteId"
                                    :options="form.ocupacoesUsuarioSolicitante"
                                    :validations="validations.ocupacaoUsuarioSolicitante"
                                    label="CBO do profissional solicitante"
                                    show-default-option
                                    text-field="nome"
                                    v-model="model.ocupacaoUsuarioSolicitanteId"
                                    value-field="id"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-input-autocomplete
                                    :disabled="!!model.ciap || isCiapRequired"
                                    :repository="repositories.cid"
                                    :requestQueryStringParams="autocompleteRequestParams.cid"
                                    :searchFields="[
                                        { key: 'codigo', searchable: true },
                                        { key: 'nome', searchable: true },
                                    ]"
                                    :text-field="c => `${formatCid(c.codigo)} - ${c.nome}`"
                                    :validations="validations.cid"
                                    @input="model.ciap = null"
                                    label="CID"
                                    placeholder="Digite o código ou o nome do CID"
                                    uppercase
                                    v-model="model.cid"
                                />
                            </rkm-col>

                            <rkm-col>
                                <rkm-form-input-autocomplete
                                    :disabled="!!model.cid"
                                    :repository="repositories.ciap"
                                    :requestQueryStringParams="autocompleteRequestParams.ciap"
                                    :searchFields="[
                                        { key: 'codigo', searchable: true },
                                        { key: 'descricao', searchable: true },
                                    ]"
                                    :text-field="c => `${c.codigo} - ${c.descricao}`"
                                    :validations="validations.ciap"
                                    @input="model.cid = null"
                                    label="CIAP"
                                    placeholder="Digite o código ou o nome do CIAP"
                                    uppercase
                                    v-model="model.ciap"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-textarea
                                    :validations="validations.hipoteseDiagnosticaJustificativa"
                                    label="Hipótese diagnóstica / Justificativa"
                                    maxlength="5000"
                                    uppercase
                                    v-model="model.hipoteseDiagnosticaJustificativa"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-textarea
                                    :validations="validations.observacao"
                                    label="Observações"
                                    maxlength="5000"
                                    uppercase
                                    v-model="model.observacao"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-textarea
                                    :validations="validations.justificativaReenvio"
                                    label="Observações do reenvio"
                                    v-model="model.justificativaReenvio"
                                />
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <rkm-row v-if="isStatusDevolvido">
                        <rkm-col>
                            <rkm-form-textarea
                                :validations="validations.justificativaDevolucao"
                                label="Justificativa"
                                v-model="model.justificativaDevolucao"
                            />
                        </rkm-col>
                    </rkm-row>
                </template>

                <rkm-area
                    no-margin-top
                    title="Movimentações"
                >
                    <template slot="trailing">
                        <rkm-button
                            v-if="additionals.allowUpdate"
                            @click="boxHistoricoMovimentacoesVisible = !boxHistoricoMovimentacoesVisible"
                            color="primary"
                            small
                        >
                            <rkm-icon :icon="boxHistoricoMovimentacoesVisible ? 'angle-double-up' : 'angle-double-down'" />
                        </rkm-button>

                        <rkm-button
                            @click="printHistoricoMovimentacoes"
                            color="info"
                            small
                        >
                            <rkm-icon icon="print" />
                        </rkm-button>
                    </template>

                    <rkm-collapse :visible="boxHistoricoMovimentacoesVisible">
                        <rkm-table
                            :items="form.historicoMovimentacoes.status"
                            :fields="fields.historicoMovimentacoesStatus"
                            hide-filters
                            sort-by="dataHoraMovimentacao"
                            sort-desc
                        >
                            <template v-slot:cell(justificativaStatus)="{ item }">
                                <rkm-button
                                    :id="uniqueId(`justificativa-status-${item.solicitacaoHistoricoId}`)"
                                    small
                                >
                                    <rkm-icon icon="comment" />
                                </rkm-button>

                                <rkm-popover
                                    :target="uniqueId(`justificativa-status-${item.solicitacaoHistoricoId}`)"
                                    placement="top"
                                    triggers="hover"
                                >
                                    {{ item.justificativaStatus }}
                                </rkm-popover>
                            </template>
                        </rkm-table>
                    </rkm-collapse>
                </rkm-area>
            </rkm-area>
        </rkm-form>

        <ModalTentativaContato
            :solicitacao="solicitacao"
            ref="ModalTentativaContato"
            show-historico
        />

        <ModalAgendamentoExameLaboratorial
            :paciente-id="form.paciente.id"
            :regulacao-solicitacao="solicitacaoAgendamentoInternoData"
            @save="handleAgendado"
            hide-agendamentos
            ref="ModalAgendamentoExameLaboratorial"
        />

        <ModalAgendamentoExameImagem
            :paciente-id="form.paciente.id"
            :regulacao-solicitacao="solicitacaoAgendamentoInternoData"
            @save="handleAgendado"
            hide-agendamentos
            ref="ModalAgendamentoExameImagem"
        />

        <ModalAgendamentoAmbulatorio
            :paciente-id="form.paciente.id"
            :regulacao-solicitacao="solicitacaoAgendamentoInternoData"
            @save="handleAgendado"
            ref="ModalAgendamentoAmbulatorio"
        />

        <ModalProtocoloAgendamento
            :data="data"
            @save="handleSaveProtocoloAgendamento"
            ref="ModalProtocoloAgendamento"
        />

        <ModalPrioridade
            :solicitacao="solicitacao"
            @save="handleSaveModalPrioridade"
            ref="ModalPrioridade"
        />

        <ModalSupervisor
            @authorized="() => afterAuthorized()"
            ref="ModalSupervisor"
        />
    </div>
</template>

<script>
// Components.
import ModalAgendamentoAmbulatorio from '@/components/ambulatorio/agendamento/components/cadastro/Modal'
import ModalAgendamentoExameImagem from '@/components/exame-imagem/agendamento/Modal'
import ModalAgendamentoExameLaboratorial from '@/components/exame-laboratorial/agendamento-exame/Modal'
import ModalHistoricoMedico from '@/components/ambulatorio/atendimento/components/historico/Modal'
import ModalImportaArquivo from '@/components/regulacao/solicitacao/components/importa-arquivo/Modal'
import ModalPrioridade from './components/prioridade/Modal'
import ModalProtocoloAgendamento from './components/protocolo-agendamento/Modal'
import ModalSupervisor from '@/components/regulacao/solicitacao/components/supervisor/Modal'
import ModalTentativaContato from '@/components/regulacao/fila/components/tentativa-contato/components/cadastro/Modal'

// Utils.
import protocoloLaboratorio from '@/utils/exame-laboratorial/impressao/protocolo'
import protocoloLaboratorioExterno from '@/utils/exame-laboratorial/impressao/protocoloExterno'
import protocoloImagem from '@/utils/exame-imagem/impressao/protocolo'
import protocoloImagemExterno from '@/utils/exame-imagem/impressao/protocoloExterno'

// Mixins.
import { repository, error, object, stringCase, mask, unmask, data, formats, file, permissao } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

// Enums.
import statusTipo from '@/enums/regulacao/statusTipo'
import regulacaoTipo from '@/enums/regulacao/tipo'
import opcaoRetiradaProtocoloAgendamento from '@/enums/regulacao/opcaoRetiradaProtocoloAgendamento'
import subclassificacao from '@/enums/cadastro/paciente/subclassificacao'
import sexo from '@/enums/cadastro/cidadao/sexo'
import tipoRegistro from '@/enums/cadastro/usuario/tipoRegistro'

// Others.
import moment from 'moment'

export default {
    components: {
        ModalAgendamentoAmbulatorio,
        ModalAgendamentoExameImagem,
        ModalAgendamentoExameLaboratorial,
        ModalHistoricoMedico,
        ModalImportaArquivo,
        ModalPrioridade,
        ModalProtocoloAgendamento,
        ModalSupervisor,
        ModalTentativaContato,
    },
    computed: {
        validations() {

            return {
                cns: { required: false, min_max_without_mask: 15, cns: true },
                cpf: { required: false, min_max_without_mask: 11, cpf: true },
                rg: { min: 6, max: 15 },
                protocoloCross: { required: this.additionals.obrigaProtocoloCross, max: 10 },
                peso: { min_value: 0.5, max_value: 500 },
                altura: { min_value: 20, max_value: 250 },
                obito: {
                    obitoEm: { required: true },
                    declaracao: { min: 1, max: 13 },
                    causa: { min: 1, max: 255 },
                },
                status: { required: true },
                nomePessoaRetiradaProtocoloAgendamento: { required: true, max: 150 },
                justificativaCancelamento: { required: true, max: 500 },
                justificativaReagendamento: { required: true, max: 500 },
                justificativaRemarcacao: { required: true, max: 500 },
                justificativaDevolucao: { required: true, max: 500 },
                justificativaReenvio: { required: true, max: 500 },
                prestadorInterno: { required: true },
                prestadorExterno: { required: true },
                dataAgendada: { required: true },
                horaAgendada: { required: true },
                usuarioSolicitante: { required: true },
                unidadeUsuarioSolicitante: { required: true },
                infraestruturaUsuarioSolicitante: { required: true },
                ocupacaoUsuarioSolicitante: { required: true },
                ciap: { required: this.isCiapRequired },
                cid: { required: !this.isCiapRequired },
                hipoteseDiagnosticaJustificativa: { max: 5000 },
                observacao: { max: 5000 },
            }
        },
        isCiapRequired() {

            return this.model.usuarioSolicitante?.registroTipoId === this.enums.tipoRegistro.COREN
        },
        autocompleteRequestParams() {

            return {
                usuario: {
                    registro_estado_id: this.additionals.usuarioRegistroEstadoId,
                },
                cid: {
                    sexo: this.form.paciente.sexoId
                        ? this.form.paciente.sexoId == this.enums.sexo.MASCULINO ? 'M' : 'F'
                        : null,
                },
                ciap: {
                    sexo_id: this.form.paciente.sexoId,
                },
            }
        },
        pesoMask() {

            const length = (this.model.peso ?? '').replace('.', '').length

            if (length <= 3) {

                return '#.##'
            }
            else if (length <= 4) {

                return '##.##'
            }
            else {

                return '###.##'
            }
        },
        status() {

            if (this.model.obito) {

                return this.form.status.filter(s => s.tipoId === this.enums.statusTipo.CANCELADO)
            }

            return this.form.status
        },
        isStatusDeAgendamento() {

            return [
                this.enums.statusTipo.AGENDADO,
                this.enums.statusTipo.REAGENDADO,
            ].includes(this.statusTipoId)
        },
        isStatusRealizado() {

            return this.statusTipoId === this.enums.statusTipo.REALIZADO
        },
        isStatusCancelado() {

            return this.statusTipoId === this.enums.statusTipo.CANCELADO
        },
        isStatusAgendado() {

            return this.statusTipoId === this.enums.statusTipo.AGENDADO
        },
        isStatusReagendado() {

            return this.statusTipoId === this.enums.statusTipo.REAGENDADO
        },
        isStatusRemarcar() {

            return this.statusTipoId === this.enums.statusTipo.REMARCAR
        },
        isStatusReenviada() {

            return this.statusTipoId === this.enums.statusTipo.REENVIADA
        },
        isStatusDevolvido() {

            return this.statusTipoId === this.enums.statusTipo.DEVOLVIDO
        },
        statusTipoId() {

            if (this.model.statusId) {

                return this.form.status.find(s => s.id === this.model.statusId).tipoId
            }

            return null
        },
        isRegulacaoTipoInterno() {

            return this.form.solicitacao.regulacaoTipoId === this.enums.regulacaoTipo.INTERNO
        },
        isRegulacaoTipoExterno() {

            return this.form.solicitacao.regulacaoTipoId === this.enums.regulacaoTipo.EXTERNO
        },
        isRegulacaoTipoAmbos() {

            return this.form.solicitacao.regulacaoTipoId === this.enums.regulacaoTipo.AMBOS
        },
        isPrestadorTipoInterno() {

            return this.form.prestadorTipo === this.enums.regulacaoTipo.INTERNO
        },
        isPrestadorTipoExterno() {

            return this.form.prestadorTipo === this.enums.regulacaoTipo.EXTERNO
        },
        data() {

            if (!this.loaded) {

                return null
            }

            return {
                additionals: this.additionals,
                form: this.form,
                model: this.model,
                fezAgendamentoAgora: this.fezAgendamentoAgora,
                isStatusAgendado: this.isStatusAgendado,
                isStatusReagendado: this.isStatusReagendado,
                isPrestadorTipoInterno: this.isPrestadorTipoInterno,
            }
        },
        solicitacaoAgendamentoInternoData() {

            return {
                ...this.clone(this.form.solicitacao),
                prestador: this.clone(this.form.prestadoresInternos
                    .find(p => p.id === this.model.prestadorInternoId) ?? null)
            }
        },
        ...mapGetters({
            loading: 'getLoading',
            cliente: 'getCliente',
            lotacao: 'getLotacao',
            customer: 'getCustomer',
        }),
    },
    created() {

        this.repositories = {
            fila: this.getConectaSusRepository('regulacao.fila'),
            solicitacao: this.getConectaSusRepository('regulacao.solicitacao'),
            impressao: this.getConectaSusRepository('impressao.regulacao'),
            cid: this.getConectaSusRepository('sigtap.cid'),
            ciap: this.getConectaSusRepository('geral.ciap'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            ambulatorio: this.getConectaSusRepository('impressao.ambulatorio')
        }

        this.load()
    },
    data() {

        return {
            loaded: false,
            additionals: null,
            form: null,
            model: null,
            boxPacienteVisible: true,
            boxInformacoesVisible: true,
            boxHistoricoMovimentacoesVisible: false,
            boxHistoricoPrioridadeVisible: false,
            boxHistoricoOutrasSolicitacoesVisible: false,
            fields: {
                itens: [
                    { key: 'codigo', label: 'Código', sortable: true, class: 'col-min' },
                    { key: 'nome', label: 'Nome', sortable: true },
                ],
                historicoMovimentacoesPrioridade: [
                    {
                        key: 'dataHoraMovimentacao',
                        label: 'Data/hora da alteração',
                        sortable: true,
                        formatter: v => this.formatDateTime(v),
                        filterByFormatted: true,
                    },
                    { key: 'prioridadeAnteriorNome', label: 'Prioridade', sortable: true },
                    { key: 'prioridadeNome', label: 'Alterado para', sortable: true },
                    { key: 'usuarioQueMovimentou', label: 'Usuário', sortable: true },
                    { key: 'motivoAlteracaoPrioridade', label: 'Motivo', sortable: true },
                ],
                historicoOutrasSolicitacoes: [
                    {
                        key: 'data',
                        label: 'Data',
                        sortable: true,
                        formatter: v => this.formatDate(v),
                        filterByFormatted: true,
                    },
                    { key: 'itens', label: 'Procedimento(s) / Especialidade' },
                    { key: 'usuarioSolicitanteNome', label: 'Profissional solicitante', sortable: true },
                    { key: 'unidadeSolicitanteNomeFantasia', label: 'Unidade solicitante', sortable: true },
                    { key: 'infraestruturaSolicitanteNome', label: 'Local de atendimento solicitante', sortable: true },
                    { key: 'unidadeReguladoraNomeFantasia', label: 'Unidade reguladora', sortable: true },
                    { key: 'infraestruturaReguladoraNome', label: 'Local de atendimento regulador', sortable: true },
                    { key: 'statusNome', label: 'Status', sortable: true },
                ],
                historicoMovimentacoesStatus: [
                    { key: 'statusNome', label: 'Status', sortable: true },
                    { key: 'prestadorDescricao', label: 'Prestador', sortable: true },
                    {
                        key: 'dataAgendada',
                        label: 'Data agendada',
                        sortable: true,
                        formatter: v => v ? this.formatDate(v) : null,
                        filterByFormatted: true,
                    },
                    { key: 'horaAgendada', label: 'Hora agendada', sortable: true },
                    { key: 'opcaoRetiradaProtocoloAgendamentoNome', label: 'Status do protocolo', sortable: true },
                    { key: 'nomePessoaRetiradaProtocoloAgendamento', label: 'Protocolo retirado por', sortable: true },
                    {
                        key: 'dataHoraMovimentacao',
                        label: 'Data/hora da movimentação',
                        sortable: true,
                        formatter: v => this.formatDateTime(v),
                        filterByFormatted: true,
                    },
                    { key: 'usuarioQueMovimentou', label: 'Usuário que atualizou', sortable: true },
                    { key: 'justificativaStatus', label: 'Justificativa', sortable: true },
                ],
            },
            enums: { statusTipo, regulacaoTipo, opcaoRetiradaProtocoloAgendamento, subclassificacao, sexo, tipoRegistro },
            others: { moment },
            initials: { form: null, model: null },
            fezAgendamentoAgora: false,
            savedProtocoloAgendamento: false,
            afterAuthorized: null,
            utils: {
                protocoloLaboratorio,
                protocoloImagem,
                protocoloLaboratorioExterno,
                protocoloImagemExterno,
            }
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleUsuarioSolicitanteInput() {

            if (!this.model.usuarioSolicitante) {

                this.form.unidadesUsuarioSolicitante = []
                this.model.unidadeUsuarioSolicitanteId = null

                this.form.infraestruturasUsuarioSolicitante = []
                this.model.infraestruturaUsuarioSolicitanteId = null

                this.form.ocupacoesUsuarioSolicitante = []
                this.model.ocupacaoUsuarioSolicitanteId = null
            }
        },
        handleUsuarioSolicitanteSelected() {

            this.form.unidadesUsuarioSolicitante = []
            this.model.unidadeUsuarioSolicitanteId = null

            this.form.infraestruturasUsuarioSolicitante = []
            this.model.infraestruturaUsuarioSolicitanteId = null

            this.form.ocupacoesUsuarioSolicitante = []
            this.model.ocupacaoUsuarioSolicitanteId = null

            this.setLoading()

            this.repositories.solicitacao.getInfoProfissional({
                listar: 'unidades',
                usuario_id: this.model.usuarioSolicitante.id,
            })
                .then(({ data }) => {

                    this.form.unidadesUsuarioSolicitante = data.form.infoProfissional.unidades

                    if (this.form.unidadesUsuarioSolicitante.length === 1) {

                        this.model.unidadeUsuarioSolicitanteId = this.form.unidadesUsuarioSolicitante[0].id

                        this.handleUnidadeUsuarioSolitanteChange()
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUnidadeUsuarioSolitanteChange() {

            this.form.infraestruturasUsuarioSolicitante = []
            this.model.infraestruturaUsuarioSolicitanteId = null

            this.form.ocupacoesUsuarioSolicitante = []
            this.model.ocupacaoUsuarioSolicitanteId = null

            if (!this.model.unidadeUsuarioSolicitanteId) return

            this.setLoading()

            this.repositories.solicitacao.getInfoProfissional({
                listar: 'infraestruturas',
                usuario_id: this.model.usuarioSolicitante.id,
                unidade_id: this.model.unidadeUsuarioSolicitanteId,
            })
                .then(({ data }) => {

                    this.form.infraestruturasUsuarioSolicitante = data.form.infoProfissional.infraestruturas

                    if (this.form.infraestruturasUsuarioSolicitante.length === 1) {

                        this.model.infraestruturaUsuarioSolicitanteId = this.form.infraestruturasUsuarioSolicitante[0].id

                        this.handleInfraestruturaUsuarioSolitanteChange()
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleInfraestruturaUsuarioSolitanteChange() {

            this.form.ocupacoesUsuarioSolicitante = []
            this.model.ocupacaoUsuarioSolicitanteId = null

            if (!this.model.infraestruturaUsuarioSolicitanteId) return

            this.setLoading()

            this.repositories.solicitacao.getInfoProfissional({
                listar: 'ocupacoes',
                usuario_id: this.model.usuarioSolicitante.id,
                infraestrutura_id: this.model.infraestruturaUsuarioSolicitanteId,
            })
                .then(({ data }) => {

                    this.form.ocupacoesUsuarioSolicitante = data.form.infoProfissional.ocupacoes

                    if (this.form.ocupacoesUsuarioSolicitante.length === 1) {

                        this.model.ocupacaoUsuarioSolicitanteId = this.form.ocupacoesUsuarioSolicitante[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        load() {

            this.setLoading()

            this.repositories.fila.editSolicitacao(this.solicitacao.id, { posicao_por_regulador: this.posicaoPorRegulador })
                .then(({ data }) => {

                    if (data.form.paciente.obito.obitoEm) {

                        data.form.paciente.obito.obitoEm = this.others
                            .moment(data.form.paciente.obito.obitoEm, 'DD/MM/YYYY')
                            .toDate()
                    }

                    if (data.form.solicitacao.dataAgendada) {

                        data.form.solicitacao.dataAgendada = this.others
                            .moment(data.form.solicitacao.dataAgendada, 'DD/MM/YYYY')
                            .toDate()
                    }

                    this.boxHistoricoMovimentacoesVisible = !data.additionals.allowUpdate

                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model

                    this.initials.form = this.clone(this.form)
                    this.initials.model = this.clone(this.model)

                    this.$watch('model.usuarioSolicitante.registroTipoId', () => {

                        this.model.ciap = null
                        this.model.cid = null
                    })

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleObito() {

            if (this.model.obito) {

                const statusCancelado = this.form.status.find(s => s.tipoId === this.enums.statusTipo.CANCELADO)

                this.model.statusId = statusCancelado ? statusCancelado.id : null
            }
        },
        handleAgendado(agendamento) {

            this.fezAgendamentoAgora = true

            if (this.additionals.moduloAgendamento === 'exame-laboratorial') {

                this.model.dataAgendada = this.others.moment(agendamento.data, 'DD/MM/YYYY').toDate()
                this.model.horaAgendada = agendamento.horaExame
            }
            else if (this.additionals.moduloAgendamento === 'exame-imagem') {

                this.model.dataAgendada = this.others.moment(agendamento.agendamentoAtual.data).toDate()
                this.model.horaAgendada = agendamento.agendamentoAtual.horaExame
            }
            else if (this.additionals.moduloAgendamento === 'ambulatorio') {

                this.model.dataAgendada = this.others.moment(agendamento.data, 'DD/MM/YYYY').toDate()
                this.model.horaAgendada = agendamento.horario
            }

            this.$refs.ModalProtocoloAgendamento.open()
        },
        handleSaveProtocoloAgendamento() {

            this.savedProtocoloAgendamento = true

            this.save()
        },
        handleSaveModalPrioridade() {

            this.$emit('prioridade-change')
            this.load()
        },
        handleSave() {

            this.$refs.Form.validate().then(valid => {

                if (!valid) {

                    if (document.querySelectorAll("#box-paciente .is-invalid").length > 0) {

                        this.boxPacienteVisible = true

                        setTimeout(() => this.$refs.Form.validate(), 300)
                    }

                    return
                }

                const save = async () => {

                    this.setLoading()

                    try {

                        await this.repositories.fila.updatePaciente(this.form.paciente.id, this.preparePacienteData())

                        if (this.isStatusDeAgendamento && this.isPrestadorTipoInterno && !this.fezAgendamentoAgora) {

                            this.openModalAgendamento()
                        }
                        else if (this.isStatusRemarcar) {

                            this.showConfirmation(
                                'A posição será alterada para a última de acordo com a prioridade. Deseja continuar?',
                                async () => this.save(),
                                async () => {},
                                this.handleError
                            )
                        }
                        else {

                            this.save()
                        }
                    }
                    catch (error) {

                        this.handleError(error)
                    }
                    finally {

                        this.unsetLoading()
                    }
                }

                let precisaAutenticacaoSupervisor = false
                const fatoresQuePrecisamDeAutenticacao = []

                if (this.additionals.statusQuePrecisamSenhaSupervisor.includes(this.model.statusId)) {

                    precisaAutenticacaoSupervisor = true
                    fatoresQuePrecisamDeAutenticacao.push('alterar para status selecionado')
                }

                if (this.isStatusAgendado) {

                    if (this.additionals.precisaSenhaSupervisorParaAgendarForaOrderPosicao) {

                        precisaAutenticacaoSupervisor = true
                        fatoresQuePrecisamDeAutenticacao.push('agendar fora da ordem de posição')
                    }

                    if (this.additionals.precisaSenhaSupervisorParaAgendarOutroRegulador) {

                        precisaAutenticacaoSupervisor = true
                        fatoresQuePrecisamDeAutenticacao.push('agendar para outro regulador')
                    }
                }

                if (precisaAutenticacaoSupervisor) {

                    this.afterAuthorized = save

                    this.showConfirmation(
                        `É necessário informar as credenciais do usuário supervisor para ${fatoresQuePrecisamDeAutenticacao.join(', ')}. Deseja continuar?`,
                        async () => this.$refs.ModalSupervisor.open()
                    )
                }
                else {

                    save()
                }
            })
        },
        openModalAgendamento() {

            if (this.additionals.moduloAgendamento === 'exame-laboratorial') {

                this.$refs.ModalAgendamentoExameLaboratorial.open()
            }
            else if (this.additionals.moduloAgendamento === 'exame-imagem') {

                this.$refs.ModalAgendamentoExameImagem.open()
            }
            else if (this.additionals.moduloAgendamento === 'ambulatorio') {

                this.openModalAgendamentoAmbulatorio()
            }
        },
        openModalAgendamentoAmbulatorio() {

            const openModal = async () => {

                if (this.additionals.ambulatorio.avisaCnsProvisorio) {

                    this.showWarningNotification('Paciente com CNS provisório.')
                }

                if (this.form.solicitacao.ambulatorioAgendamentoId) {

                    this.$refs.ModalAgendamentoAmbulatorio.edit(this.form.solicitacao.ambulatorioAgendamentoId)
                }
                else {

                    this.$refs.ModalAgendamentoAmbulatorio.create()
                }
            }

            if (this.additionals.ambulatorio.cadastroPacienteVencido) {

                this.showWarningNotification(`Paciente com cadastro temporário desatualizado. Agendamento não permitido.`)
            }
            else if (this.form.paciente.subclassificacaoId === this.enums.subclassificacao.TEMPORARIO
                && this.additionals.avisaCnsTemporarioInvalido
            ) {

                this.showConfirmation(`Paciente com cadastro temporário. Deseja continuar?`, openModal)
            }
            else {

                openModal()
            }
        },
        save() {

            this.setLoading()

            this.repositories.fila.updateSolicitacao(this.solicitacao.id, this.prepareData())
                .then(() => {

                    if (this.model.prestadorExternoId) {
                        this.handleImpressao()
                    } else {

                        this.showSaveNotification()
                        this.$emit('save')
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleImpressao() {

            this.setLoading()

            this.repositories.fila.getAtendimentos({id: this.solicitacao.id})
                .then(({ data }) => {

                    const descricaoDestino = this.form.prestadoresExternos.find(prestador => prestador.id == this.model.prestadorExternoId).nome
                    const dataFormatada = this.others.moment(this.model.dataAgendada).format('DD/MM/YYYY')
                    const horaFormatada = this.model.horaAgendada.slice(0, 5);

                    this.solicitacao['descricaoDestino'] = descricaoDestino
                    this.solicitacao['dataCompletaAgendamento'] = dataFormatada + ' às ' + horaFormatada

                    this.solicitacao['agendamentoData'] = data

                    if (data && data.sistema) {
                        this.solicitacao['sistema'] = data.sistema
                    }

                    if (data && data.examesIncluidos) {
                        this.solicitacao['examesIncluidos'] = data.examesIncluidos
                    }

                    if (data && data.infraestruturaSolicitante) {
                        this.solicitacao['infraestruturaSolicitante'] = data.infraestruturaSolicitante
                    }

                    if (data && data.prestadorExterno) {
                        this.solicitacao['prestadorExterno'] = data.prestadorExterno
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading(this.$nextTick().then(this.print())))
        },
        print() {

            if (this.additionals.moduloAgendamento === 'exame-imagem') {

                this.printExameImagem()
            } else if (this.additionals.moduloAgendamento === 'exame-laboratorial') {

                this.printExameLaboratorial()
            } else if (this.additionals.moduloAgendamento === 'ambulatorio') {

                this.printAmbulatorio()
            }
        },
        printExameImagem() {

            this.utils.protocoloImagemExterno.print({
                ...this.solicitacao,
                cliente: this.cliente.nome,
                usuarioLogado: this.lotacao.usuario.nome,
                logotipo: this.customer.logotipo,
                regulacao: true,
            });

            this.showSaveNotification()
            this.$emit('save')
        },
        printExameLaboratorial() {

            this.utils.protocoloLaboratorioExterno.print({
                ...this.solicitacao,
                cliente: this.cliente.nome,
                usuarioLogado: this.lotacao.usuario.nome,
                logotipo: this.customer.logotipo,
                regulacao: true,
            });

            this.showSaveNotification()
            this.$emit('save')
        },
        printAmbulatorio() {

            const request = this.repositories.ambulatorio.agendamentoExterno(this.solicitacao.id)

            request
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .catch(this.handleError)
                .finally(() => {
                    this.showSaveNotification()
                    this.$emit('save')
                })
        },
        prepareData() {

            const data = this.clone(this.model)

            data.lotacaoUsuarioSolicitanteId = null

            if (this.model.ocupacaoUsuarioSolicitanteId) {

                const ocupacaoUsuarioSolicitante = this.form.ocupacoesUsuarioSolicitante
                    .find(o => o.id === this.model.ocupacaoUsuarioSolicitanteId)

                if (ocupacaoUsuarioSolicitante) {

                    data.lotacaoUsuarioSolicitanteId = ocupacaoUsuarioSolicitante.lotacaoId
                }
            }

            this.formateDates(data, [
                'dataAgendada'
            ], 'DD/MM/YYYY')

            this.createIdKeysToObject(data, [
                'usuarioSolicitante',
                'cid',
                'ciap'
            ])

            if (data.horaAgendada) {

                data.horaAgendada = data.horaAgendada.substring(0, 5)
            }

            data.paciente = {
                obito: {
                    obitoEm: this.model.obito
                        ? this.others.moment(this.form.paciente.obito.obitoEm).format('DD/MM/YYYY')
                        : null,
                    declaracao: this.model.obito ? this.form.paciente.obito.declaracao : null,
                    causa: this.model.obito ? this.form.paciente.obito.causa : null,
                    cidId: this.model.obito && this.form.paciente.obito.cid ? this.form.paciente.obito.cid.id : null,
                    usuarioId: this.model.obito && this.form.paciente.obito.usuario
                        ? this.form.paciente.obito.usuario.id
                        : null,
                },
            }

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        preparePacienteData() {

            const data = {
                cns: this.unMaskCns(this.form.paciente.cns),
                cpf: this.form.paciente.cpf ? this.unMaskCpf(this.form.paciente.cpf) : null,
                rg: this.form.paciente.rg,
            }

            if (this.additionals.exibeProtocoloCross) {

                data.protocoloCross = this.form.paciente.protocoloCross
            }

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        clearFromTipoPrestador() {

            this.model.prestadorInternoId = null
            this.model.prestadorExternoId = null

            this.model.dataAgendada = null
            this.model.horaAgendada = null
        },
        printHistoricoMovimentacoes() {

            this.setLoading()

            this.repositories.impressao.historicoMovimentacaoSolicitacao(this.solicitacao.id)
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        hasPermissao(hash) {

            return this.verificarPermissao(hash);
        },
    },
    mixins: [repository, error, object, stringCase, mask, unmask, data, formats, file, permissao],
    props: {
        solicitacao: { type: Object, required: true },
        posicaoPorRegulador: { type: Boolean, required: true },
    },
    watch: {
        data: {
            deep: true,
            handler(data) {

                this.$emit('data-change', data)
            }
        },
    }
}
</script>